module.exports = __webpack_public_path__ + "img/IR.2f67c196.png";